import { Seo, breadcrumbSchema } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { Breadcrumb } from "@/components/Breadcrumb";
import { useLang } from "@/i18n/LangContext";
import { RichParagraph } from "@/pages/Legal";

const Section = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-display text-xl md:text-2xl font-bold tracking-tight">{title}</h2>
    <div className="mt-4 space-y-3 text-sm md:text-base leading-relaxed text-plum/85">{children}</div>
  </section>
);

export default function Privacy() {
  const { t } = useLang();
  const p = t.privacyPage;

  return (
    <>
      <Seo
        title={p.seo.title}
        description={p.seo.description}
        path="/politique-de-confidentialite"
        schemas={[
          breadcrumbSchema([
            { name: t.common.home, path: "/" },
            { name: p.breadcrumb, path: "/politique-de-confidentialite" },
          ]),
        ]}
      />
      <div className="px-5 md:px-10 pt-36 md:pt-44 pb-24 md:pb-32" data-testid="privacy-page">
        <div className="mx-auto max-w-3xl">
          <Breadcrumb items={[{ label: t.common.home, to: "/" }, { label: p.breadcrumb }]} />
          <Reveal>
            <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tighter">
              {p.h1}
            </h1>
            <p className="mt-4 text-sm text-plum/60">{p.updated}</p>
          </Reveal>
          <Reveal delay={0.1}>
            {p.sections.map((s) => (
              <Section key={s.title} title={s.title}>
                {s.paragraphs.map((para, i) => (
                  <RichParagraph key={i} text={para} />
                ))}
              </Section>
            ))}
          </Reveal>
        </div>
      </div>
    </>
  );
}
